export enum Chart {
  Region = "Region",
  Country = "Country",
  Site = "Site"
}
export enum Tile {
  UserStatus = "UserStatus",
  Training = "Trainings",
  Documents = "Documents",
  Messages = "Messages",
  SafetyReports = "SafetyReports"
}

export enum TileSuffixText {
  SelectedSites = "Selected Sites",
  SelectedCountries = "Selected Countries",
  SelectedRegions = "Selected Regions",
  AllRegions = "All Regions"
}

export enum SeriesLableWidthConfig {
  Below_499 = 3,
  Between_500_To_899 = 5,
  Between_900_To_1365 = 8,
  Above_1366 = 10
}
